import { useIsFeatureEnabled } from '../utils/features';

export type CapacityFeatureFlags = {
	/**
	 * A flag that controls wether or not the capacity feature is enabled.
	 */
	isCapacityFeatureEnabled: boolean;
	/**
	 * A flag that controls wether or not the advanced entitlements feature is enabled.
	 */
	isAdvancedEntitlementFeatureEnabled: boolean;
};

// prettier-ignore
export function useCapacityFeatureFlags(): CapacityFeatureFlags {
	const assetFlag = useIsFeatureEnabled('i360-asset-team-capacity-pricing') as boolean;
	const insightFlag = useIsFeatureEnabled('i360i-release-capacity-pricing') as boolean;
	const isAssetApp = typeof assetFlag !== 'undefined';

	return {
		isCapacityFeatureEnabled: isAssetApp ? assetFlag : insightFlag,
		isAdvancedEntitlementFeatureEnabled: isAssetApp ? assetFlag : insightFlag,
	};
}
